export default __webpack_public_path__ + "static/media/logo_intercites.70701674.svg";